import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

function pickActiveSite(user, sites) {
  if (user.role === "staff") return user.site_id || null;
  const stored = localStorage.getItem("site_id");
  if (stored && sites.some((s) => s.site_id === stored)) return stored;
  return sites[0]?.site_id || null;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [sites, setSites] = useState([]);
  const [activeSite, setActive] = useState(null);
  const [ready, setReady] = useState(false);

  const applyMe = (data) => {
    setUser(data.user);
    setSites(data.sites || []);
    const site = pickActiveSite(data.user, data.sites || []);
    setActive(site);
    if (site) localStorage.setItem("site_id", site);
    else localStorage.removeItem("site_id");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then((r) => applyMe(r.data))
      .catch(() => { localStorage.removeItem("token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    const me = await api.get("/auth/me");
    applyMe(me.data);
    return me.data.user;
  };

  const logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("site_id");
    setUser(false);
    setSites([]);
    setActive(null);
  };

  const setActiveSite = (siteId) => {
    localStorage.setItem("site_id", siteId);
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ user, sites, activeSite, ready, login, logout, setActiveSite }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
